<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :get-data-func="getEvents"
      :headers="userHeaders"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      ref="list"
    >
      <template slot="title">
        <v-layout align-center>
          <span class="pr-4">待处理事件</span>
          <v-radio-group row shrink v-model="currentRole" v-if="multipleRole">
            <v-radio v-if="isTrafficAdmin" label="已提交" :value="VIOLATION_ROLE.TRAFFIC_ADMIN"></v-radio>
            <v-radio v-if="isAlarmAdmin" label="待初步确认" :value="VIOLATION_ROLE.ALARM_ADMIN"></v-radio>
            <v-radio v-if="isViolationAdmin" label="待最终确认" :value="VIOLATION_ROLE.VIOLATION_ADMIN"></v-radio>
          </v-radio-group>
        </v-layout>
      </template>
      <!--<template slot="title-action">-->
      <!--<l-option-list-->
      <!--:options="moreActions"-->
      <!--@delete="deleteUser(selected)"-->
      <!--&gt;-->
      <!--<v-btn icon slot="activator">-->
      <!--<v-icon>$vuetify.icons.more</v-icon>-->
      <!--</v-btn>-->
      <!--</l-option-list>-->
      <!--</template>-->
      <template slot="title-action">
        <v-menu v-if="multipleRole">
          <v-btn slot="activator" flat color="primary">上报事件</v-btn>
          <v-list dense>
            <v-list-tile @click="submit(role)" v-for="role of submitTypeList" :key="role">
              <v-list-tile-title>{{VIOLATION_ROLE_TEXT[role]}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn v-else slot="activator" @click="submit(currentRole)" flat color="primary">上报事件</v-btn>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="handle(item)" color="primary" flat>
            {{currentRole === VIOLATION_ROLE.TRAFFIC_ADMIN ? '查看':'处理'}}
          </v-btn>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="openSelectTypeDialog()"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
    <v-dialog max-width="300px" v-model="selectTypeDialog.activate">
      <v-card>
        <v-card-title>
          <span class="title pl-2">选择上报类型</span>
          <v-spacer></v-spacer>
          <v-btn icon class="ma-0" @click="closeSelectTypeDialog">
            <v-icon>$vuetify.icons.clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-list class="py-0">
          <v-divider></v-divider>
          <template v-for="role in submitTypeList">
            <v-list-tile :key="role" @click="submit(role)" class="px-2">
              <v-list-tile-action>
                <v-icon>$vuetify.icons.role</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{VIOLATION_ROLE_TEXT[role]}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider :key="role + 'divider'"></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-dialog>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils/time'
// import LOptionMenu from '../../../components/LOptionMenu'
import {VIOLATION_ROLE, VIOLATION_ROLE_TEXT, RoleSequence, ViolationEvent} from '../../../object'

export default {
  name: 'ViolationEventManagement',
  data: () => ({
    VIOLATION_ROLE,
    VIOLATION_ROLE_TEXT,
    userHeaders: [
      {text: '车辆号牌', value: 'plate', align: 'left', placeholder: 'N/A'},
      // {text: '电话号码', value: 'phone', align: 'right', placeholder: 'N/A'},
      {text: '违章区域', value: 'area', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '违章类型', value: 'typeName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '上报时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
    statusMap: {
      [VIOLATION_ROLE.TRAFFIC_ADMIN]: ViolationEvent.HAS_SUBMITTED,
      [VIOLATION_ROLE.ALARM_ADMIN]: ViolationEvent.NEED_PRELIMINARY_CONFIRM,
      [VIOLATION_ROLE.VIOLATION_ADMIN]: ViolationEvent.NEED_FINAL_CONFIRM
    },
    // 对应list显示的内容
    currentRole: null,
    selectTypeDialog: {
      activate: false,
      type: null
    }
  }),
  computed: {
    self () {
      return this.$store.state.login.self
    },
    isAlarmAdmin () {
      return this.self.isRoleOf(VIOLATION_ROLE.ALARM_ADMIN)
    },
    isTrafficAdmin () {
      return this.self.isRoleOf(VIOLATION_ROLE.TRAFFIC_ADMIN)
    },
    isViolationAdmin () {
      return this.self.isRoleOf(VIOLATION_ROLE.VIOLATION_ADMIN)
    },
    availableRoles () {
      return RoleSequence.filter(role => this.self.isRoleOf(role))
    },
    // 去掉admin提交
    submitTypeList () {
      let list = this.availableRoles.slice(0)
      let i = list.indexOf(VIOLATION_ROLE.VIOLATION_ADMIN)
      if (i > -1) {
        list.splice(i, 1)
      }
      return list
    },
    multipleRole () {
      return this.availableRoles.length > 1
    }
  },
  watch: {
    currentRole () {
      this.$refs.list.refresh(true)
    }
  },
  methods: {
    openSelectTypeDialog () {
      if (this.multipleRole) {
        this.selectTypeDialog = {
          activate: true,
          type: this.currentRole
        }
      }
      else {
        this.submit(this.currentRole)
      }
    },
    closeSelectTypeDialog () {
      this.selectTypeDialog = {
        activate: false,
        type: null
      }
    },
    async submit (role) {
      if (this.$L.tab.find(tab => tab.name === 'ViolationEventSubmit')) {
        let {close} = await this.$L.confirm({
          title: '提示',
          icon: '$vuetify.icons.alert',
          iconColor: 'warning',
          text: '请您完成当前上报事件后再上报新事件',
          disableCancel: true
        })
        close()
      }
      else {
        this.$router.push(
          {
            name: 'ViolationEventSubmit',
            query: {role}
          }
        )
      }
    },
    // openUserDialog () {
    //   this.userDialog = {
    //     activate: true,
    //     form: {
    //       name: '',
    //       loginId: '',
    //       password: '',
    //       passwordAgain: ''
    //     },
    //     checkMessage: ''
    //   }
    //   this.$refs.addUser.reset()
    // },
    handle (item) {
      let nameMap = {
        [VIOLATION_ROLE.TRAFFIC_ADMIN]: 'ViolationEventDetails',
        [VIOLATION_ROLE.ALARM_ADMIN]: 'ViolationEventHandle',
        [VIOLATION_ROLE.VIOLATION_ADMIN]: 'ViolationEventConfirm'
      }
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: nameMap[this.currentRole],
          params: {
            plate: item.plate
          },
          query: {
            id: item.id
          }
        })
        // if (status === 'new') {
        //   this.$router.push({name: 'NewUser'})
        // }
        // else {
        //   this.$router.push({
        //     name: 'UserDetails',
        //     params: {loginId: item.loginId},
        //     query: {id: item.id}
        //   })
        // }
      }
    },
    async getEvents ({pagination, sortStack, filterItems, search}) {
      let status = this.currentRole === VIOLATION_ROLE.TRAFFIC_ADMIN ? undefined : this.statusMap[this.currentRole]
      return this.$store.dispatch('violation/getEvents', {
        pagination,
        sortStack,
        filter: filterItems,
        status,
        search: {key: 'plate', value: search},
        self: this.currentRole === VIOLATION_ROLE.TRAFFIC_ADMIN
      })
    }
  },
  activated () {
    if (this.$route.params.refresh) {
      this.$refs.list.refresh()
    }
  },
  created () {
    this.currentRole = this.availableRoles[0] || null
  }
}
</script>

<style scoped>

</style>
